import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Dashboard from "./Components/Pages/Dashboard/Dashboard";
import Login from "./Components/Pages/Login/Login";
import Products from "./Components/Pages/product/product";
import Sales from "./Components/Pages/sales/sales";
import Orders from "./Components/Pages/Orders/orders";
import Categories from "./Components/Pages/Categories/Categories";
import Stores from "./Components/Pages/Store/store";
import Suppliers from "./Components/Pages/Suppliers/Suppliers";
import Brands from "./Components/Pages/brands/brands";
import PendingIndent from "./Components/Pages/pendingindent/pendingindent";
import RecentStock from "./Components/Pages/recentstock/recentstock";
import MostOrdered from "./Components/Pages/mostorder/mostordered";
import SingleProduct from "./Components/Pages/product/singleproduct";
// import { ProductProvider } from "./Components/Pages/context/productcontext";
import Customer from "./Components/Pages/Customer/customer";
import Sale from "./Components/Pages/sale/sale";
import TodaySale from "./Components/Pages/today sale/todaysale";
import RecentOrders from "./Components/Pages/recentorders/recentorders";
import PaymentType from "./Components/Pages/Reports/paymenttype";
import SaleByStore from "./Components/Pages/Reports/salebystore";
import SaleByEmploye from "./Components/Pages/Reports/salebyemployee";
import SaleByCategory from "./Components/Pages/Reports/salebycategory";
import SaleByProduct from "./Components/Pages/Reports/salebyproduct";
import Refund from "./Components/Pages/refund/refund";
import SaleByGst from "./Components/Pages/Reports/salebygst";
import SaleByGstdetails from "./Components/Pages/Reports/salebygstdeatils";
import AddProductInventory from "./Components/Pages/product/AddProductInventory";
import ProtectedRoute from "./Components/Config/ProtectedRoute";
import QuotationReview from "./Components/Pages/Customer/QuotationReview";
import Scanner from "./Components/BarcodeScan/Barcodescan";
import WeeklySalesReport from "./Components/Pages/Reports/WeekSales";
import TodayTransactions from "./Components/Pages/Reports/TodayTransactions";
import EstimateList from "./Components/Pages/Customer/EstimateList";

function App() {
  return (
    <Router>
      <div>
        {/* <ProductProvider> */}
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/products" element={<Products></Products>}></Route>
          <Route path="/sales" element={<Sales></Sales>}></Route>
          <Route path="/refund" element={<Refund></Refund>}></Route>
          <Route path="/sale" element={<Sale></Sale>}></Route>
          <Route path="/todaysale" element={<TodaySale></TodaySale>}></Route>
          <Route
            path="/recentorders"
            element={<RecentOrders></RecentOrders>}
          ></Route>
          <Route path="/orders" element={<Orders></Orders>}></Route>
          <Route path="/categories" element={<Categories></Categories>}></Route>
          <Route path="/stores" element={<Stores></Stores>}></Route>
          <Route path="/suppliers" element={<Suppliers></Suppliers>}></Route>
          <Route path="/brands" element={<Brands></Brands>}></Route>
          <Route
            path="/pendingindent"
            element={<PendingIndent></PendingIndent>}
          ></Route>
          <Route
            path="/recentstock"
            element={<RecentStock></RecentStock>}
          ></Route>
          <Route
            path="/mostorder"
            element={<MostOrdered></MostOrdered>}
          ></Route>
          <Route path="/customer" element={<Customer></Customer>}></Route>
          <Route
            path="/productdetails"
            element={<SingleProduct></SingleProduct>}
          ></Route>
          <Route
            path="/paymenttype"
            element={<PaymentType></PaymentType>}
          ></Route>
          <Route
            path="/salebystore"
            element={<SaleByStore></SaleByStore>}
          ></Route>
          <Route
            path="/salebyemploye"
            element={<SaleByEmploye></SaleByEmploye>}
          ></Route>
          <Route
            path="/salebycategory"
            element={<SaleByCategory></SaleByCategory>}
          ></Route>
          <Route
            path="/salebyproduct"
            element={<SaleByProduct></SaleByProduct>}
          ></Route>
          <Route path="/salebygst" element={<SaleByGst></SaleByGst>}></Route>
          <Route
            path="/salebygstdetails"
            element={<SaleByGstdetails></SaleByGstdetails>}
          ></Route>
          <Route
            path="/addProdctInventory"
            element={<AddProductInventory></AddProductInventory>}
          ></Route>
          <Route
            path="/quotationreview/:estimateId"
            element={<QuotationReview></QuotationReview>}
          ></Route>
          <Route
            path="/Estimate-List"
            element={<EstimateList></EstimateList>}
          ></Route>

          <Route path="/scanner" element={<Scanner></Scanner>}></Route>

          <Route path="/weekly-sales" element={<WeeklySalesReport />} />
          <Route path="/today-transactions" element={<TodayTransactions />} />
        </Routes>
        {/* </ProductProvider> */}
      </div>
    </Router>
  );
}

export default App;
